export default defineNuxtRouteMiddleware(async () => {
  const { isAdmin } = useUserRole()

  if (!isAdmin.value) {
    return navigateTo('/')
  }
})
